import type { Draft, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface IState {
  price?: any;
  status: 'idle' | 'loading' | 'success' | 'failed';
  error?: unknown;
}
export const initialState: IState = {
  error: null,
  status: 'idle',
};

const reducers = {
  onFetchPriceFailure: (state: Draft<IState>, action: PayloadAction<any>) => {
    state.status = 'failed';
    state.error = action.payload.message;
  },
  onFetchPriceSuccess: (state: Draft<IState>, action: PayloadAction<any>) => {
    state.status = 'success';
    state.price = action.payload?.shardeum?.usd;
  },
};

const sagaActions = {
  fetchPrice: (state: Draft<IState>, _action: PayloadAction<undefined>) => {
    state.status = 'loading';
  },
};


export const shmSlice = createSlice({
  initialState,
  name: 'shm',
  reducers: {
    ...reducers,
    ...sagaActions,
  },
});

export default shmSlice.reducer;
export const { actions } = shmSlice;
